import {
  completeQuestionSteps,
  type QuestionFlowStep,
} from "../components/elements/question-flow-model";

/**
 * Prefer suspend/run steps that include the full server-injected sequence
 * (background, supporting docs, instructions, webSearch) over agent args that
 * only list the three core review fields.
 */
export function preferReviewQuestionSteps(
  argsSteps: unknown,
  fallbackSteps?: QuestionFlowStep[] | null
): QuestionFlowStep[] {
  const fromArgs = completeQuestionSteps(argsSteps);
  const fromFallback = completeQuestionSteps(fallbackSteps);
  const argsHasWebSearch = fromArgs.some((step) => step.id === "webSearch");
  const fallbackHasWebSearch = fromFallback.some((step) => step.id === "webSearch");
  const argsHasOptional = fromArgs.some(
    (step) =>
      step.id === "backgroundInfo" ||
      step.id === "agentInstructions" ||
      step.id === "supportingDocuments"
  );
  const fallbackHasOptional = fromFallback.some(
    (step) =>
      step.id === "backgroundInfo" ||
      step.id === "agentInstructions" ||
      step.id === "supportingDocuments"
  );
  if (fallbackHasWebSearch && !argsHasWebSearch) return fromFallback;
  if (fallbackHasOptional && !argsHasOptional) return fromFallback;
  if (fromFallback.length > fromArgs.length) return fromFallback;
  if (fromArgs.length > 0) return fromArgs;
  return fromFallback;
}
